<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" sm="12" xs="12" class="d-flex justify-content-between">
        <button
          v-if="verificBead == false && this.box && ($store.getters.get_rol.id == 2 || $store.getters.get_rol.id == 4)"
          @click="mtdOpenModalOpenBead" type="button" class="btn btn-sm text-white" style="background: #efc603">
          <i class="fas fa-cash-register"></i> Abrir Caja
        </button>
        <!-- Botón para cerrar caja -->
        <button
          v-if="verificBead == true && this.box && ($store.getters.get_rol.id == 2 || $store.getters.get_rol.id == 4)"
          @click="mtdCloseBead" type="button" class="btn btn-sm text-white" style="background: #efc603">
          <i class="fas fa-cash-register"></i> Cerrar Caja
        </button>
        <button
          v-if="($store.getters.get_rol.id == 2 || $store.getters.get_rol.id == 4)"
          @click="mtdOpenModalWsp" type="button" :class="'btn btn-sm text-white '+instanceColor">
          <i class="fab fa-whatsapp"></i> Estado Wsp: {{ instanceState }}
        </button>
        <button @click="mtdBackRol" type="button" class="btn btn-sm text-white" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Cambiar de rol
        </button>
      </CCol>
    </CRow>
    <CCardBody>
      <CRow class="mt-2" v-if="mostrarWidget">
        <CCol sm="6" lg="3">
          <CWidgetIcon :header="'S/. ' + totalApertura" text="Apertura de Caja" color="gradient-info">
            <!-- <CIcon name="cil-settings" width="24" /> -->
            <i class="fas fa-solid fa-sack-dollar fa-2x"></i>
          </CWidgetIcon>
        </CCol>
        <CCol sm="6" lg="3">
          <CWidgetIcon :header="'S/. ' + totalIngresos" text="Total de Ingresos" color="gradient-warning">
            <!-- <CIcon name="cil-settings" width="24" /> -->
            <i class="fas fa-solid fa-coins fa-2x"></i>
          </CWidgetIcon>
        </CCol>
        <CCol sm="6" lg="3">
          <CWidgetIcon :header="'S/. ' + totalCaja" text="Monto Total en Caja" color="gradient-success">
            <i class="fas fa-solid fa-cash-register fa-2x"></i>
          </CWidgetIcon>
        </CCol>
        <CCol sm="6" lg="3">
          <CWidgetIcon :header="String(totalCitas)" text="Total de Citas" color="gradient-primary">
            <i class="fas fa-solid fa-user-clock fa-2x"></i>
          </CWidgetIcon>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="6">
          <CCard>
            <CCardHeader class="text-center text-uppercase font-weight-bold">
              Ingresos del Día
            </CCardHeader>
            <CCardBody>
              <ChartDaycharge />
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md="6">
          <CCard>
            <CCardHeader class="text-center text-uppercase font-weight-bold">
              Ingresos del Mes
            </CCardHeader>
            <CCardBody>
              <ChartMonthcharge />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" md="12">
          <transition name="fade">
            <CCard v-if="show">
              <CCardHeader class=" text-center text-uppercase font-weight-bold">
                Ingresos Anuales
                <div class="card-header-actions">
                  <CLink class="card-header-action btn-minimize" @click="isCollapsed = !isCollapsed">
                    <CIcon :name="`cil-chevron-${isCollapsed ? 'bottom' : 'top'}`" />
                  </CLink>
                </div>
              </CCardHeader>
              <CCollapse :show="isCollapsed" :duration="400">
                <CCardBody>
                  <ChatAnnualCharge :key="isCollapsed ? 1 : 0" />
                </CCardBody>
              </CCollapse>
            </CCard>
          </transition>
        </CCol>
      </CRow>
    </CCardBody>
    <cModalOpenBead :title="modalOpenBead.title" :boo_modal="modalOpenBead.modal_form"
      @closeModalOpenBead="closeModalOpenBead" @save="handleSave">
    </cModalOpenBead>
    <cModalWsp
      @mtdCloseModalWsp="mtdCloseModalWsp"
      :boo_modal="modalWsp.modal_form"
      :title="modalWsp.title"
      :id_company="modalWsp.id_company"
      :item="modalWsp.item"
      :token="tokenWsp"
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import cModalOpenBead from "../caja/modals/cModalOpenBead.vue";
import ChartDaycharge from "./Components/ChartDayCharge.vue";
import ChartMonthcharge from "./Components/ChartMontCharge.vue";
import ChatAnnualCharge from './Components/ChatAnnualCharge.vue'
import cModalWsp from './modals/cModalWsp.vue';

export default {
  name: "home-adminCompany",
  components: {
    cModalOpenBead,
    ChartDaycharge,
    ChartMonthcharge,
    // CharPayment,
    ChatAnnualCharge,
    cModalWsp
  },
  data() {
    return {
      prefix: "beads",
      box: false,
      verificBead: false,
      modalOpenBead: {
        title: "Registrar monto de inicio",
        modal_form: false,
      },
      company: {
        logo: "",
      },
      totalApertura: "",
      totalIngresos: "",
      totalCaja: "",
      totalCitas: "",
      filter: {
        init: null,
        end: null,
      },
      //Collapse
      show: true,
      isCollapsed: true,
      chartIcome: {
        data: [],
        methodsPayment: []
      },
       /** wsp */
      tokenWsp:null,
      instance:{},
      instanceState:"",
      instanceColor:"",
      /** modal wsp */
      modalWsp: {
        title: "",
        modal_form: false,
        item: {
          id:0,
          instance_name:"",
          instance_id:"",
          conected:"",
          state:""
        },
      },
    };
  },
  computed: {
    mostrarWidget() {
      return this.$store.getters.get_rol.id === 4;
    },
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.showQuote();
    this.showBead();
    this.showCompany();
    // console.log(this.$store.getters.get_rol);

  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBackRol: function () {
      this.$store.commit("mt_set_rol", null);
    },
    mtdCloseBead: function () {
      this.$parent.setView("close_bead");
    },
    mtdOpenModalOpenBead() {
      this.modalOpenBead = {
        title: "Aperturar Caja",
        modal_form: true,
      };
    },
    closeModalOpenBead() {
      this.modalOpenBead = {
        modal_form: false,
      };
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
            this.bead = this.verificBead == true ? response.data : {};
            this.totalApertura = response.data.initial;
            this.totalIngresos = response.data.income;
            this.totalCaja = response.data.final;
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    showCompany() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showCompany/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            // this.company.logo = response.data.logo;
            this.box = response.data.company.box;
            this.tokenWsp = response.data.company.instance_id;
            let temp = response.data.instance;
            this.instance = temp.original.data;
            this.instanceState=this.instance.phone_connected == false?'DESCONECTADO':'CONECTADO'
            this.instanceColor = this.instanceState == 'DESCONECTADO'?'btn-warning':'btn-success';
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    showQuote() {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/quotes",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          this.data = response.data.data;
          this.totalCitas = this.data.length;
          // console.log(this.totalCitas);
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    handleSave() {
      this.showBead();
      this.modalOpenBead = {
        modal_form: false,
      };
    },
    /** graficos1 */
    dataCamalDisp() {
      const hasCamalDispatchData = this.camalDisp.quantity_kg > 0 || this.camalDisp.peso_neto > 0;
      return [
        {
          label: 'CANTIDAD KG',
          backgroundColor: hasCamalDispatchData ? '#96afe9' : '#CCCCCC',
          data: hasCamalDispatchData ? [this.camalDisp.quantity_kg] : [1],
        },
        {
          label: 'PESO NETO',
          backgroundColor: hasCamalDispatchData ? '#d096e9' : '#CCCCCC',
          data: hasCamalDispatchData ? [this.camalDisp.peso_neto] : [1],
        }
      ];
    },
    //** wsp */
    mtdOpenModalWsp: function(){
      this.modalWsp.modal_form=true;
      this.modalWsp.title="Instancia de wsp";
      this.modalWsp.item = this.instance;
    },
    mtdCloseModalWsp: function(action){
      this.modalWsp.modal_form=false;
      this.modalWsp.item = {
        id:0,
        instance_name:"",
        instance_id:"",
        conected:"",
        state:""
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
